exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__wrapper___co_Go .index-module__text___2W0Nh{color:#707070;text-transform:uppercase;letter-spacing:.5px;font-weight:500;margin-top:1rem}.index-module__wrapper___co_Go .index-module__grid___1vFx_{display:grid;gap:1em}.index-module__wrapper___co_Go .index-module__item-2___1HIsJ{z-index:8}.index-module__wrapper___co_Go .index-module__item-3___2Kjny{z-index:7}", ""]);

// exports
exports.locals = {
	"wrapper": "index-module__wrapper___co_Go",
	"text": "index-module__text___2W0Nh",
	"grid": "index-module__grid___1vFx_",
	"item-2": "index-module__item-2___1HIsJ",
	"item-3": "index-module__item-3___2Kjny"
};